const host = window.location.hostname;

// FIXME VER AS ROTAS DE PROD
const configs = {
  localhost: {
    name: "development",
    sentryDns: "",
    owner: "QuiteJá",
    ownerUrl: "https://quiteja.com.br",
    pageTitle: "strategy - DEVOPS",
    cookiesDomain: 'localhost',
    apiUrl: "http://localhost:5502/v1",
    logo: "https://www.google.com/url?sa=i&source=images&cd=&cad=rja&uact=8&ved=2ahUKEwju-YP5ubngAhUZJ7kGHW3sBh0QjRx6BAgBEAU&url=https%3A%2F%2Fwww.vexels.com%2Fpng-svg%2Fpreview%2F153290%2Fprocessor-colored-stroke-icon&psig=AOvVaw1WUKC5hk0o7m5ZshcC5XiZ&ust=1550172819720274",
    authUrl: "http://localhost:5502/oauth/login",
    appsUrl: "http://localhost:9292/#/my-apps",
    tasksUrl: "http://localhost:5300/v1",
    healthCheckUrl: "http://localhost:5528/v1",
  },
  "strategy.quiteja.staging.gorillascode.com": {
    name: "staging",
    sentryDns:
      "https://cba67de0335b4c51b97cbc4719a7f6f9@o92838.ingest.sentry.io/5496390",
    owner: "QuiteJá",
    ownerUrl: "https://quiteja.com.br",
    pageTitle: "strategy - STAGING",
    cookiesDomain: '.strategy.quiteja.staging.gorillascode.com',
    apiUrl: "https://api.strategy.quiteja.staging.gorillascode.com/v1",
    logo: "https://www.google.com/url?sa=i&source=images&cd=&cad=rja&uact=8&ved=2ahUKEwju-YP5ubngAhUZJ7kGHW3sBh0QjRx6BAgBEAU&url=https%3A%2F%2Fwww.vexels.com%2Fpng-svg%2Fpreview%2F153290%2Fprocessor-colored-stroke-icon&psig=AOvVaw1WUKC5hk0o7m5ZshcC5XiZ&ust=1550172819720274",
    authUrl:
      "https://api.strategy.quiteja.staging.gorillascode.com/oauth/login",
    appsUrl: "https://auth.staging.gorillascode.com",
    tasksUrl: "https://tasks.quiteja.staging.gorillascode.com/v1",
    healthCheckUrl: "https://api.healthcheck.gorillascode.com/v1",
  },
  "strategy.quiteja.com.br": {
    name: "production",
    sentryDns:
      "https://cba67de0335b4c51b97cbc4719a7f6f9@o92838.ingest.sentry.io/5496390",
    owner: "QuiteJá",
    ownerUrl: "https://quiteja.com.br",
    cookiesDomainL: 'strategy.quiteja.com.br',
    pageTitle: "strategy",
    apiUrl: "https://api.strategy.quiteja.com.br/v1",
    logo: "https://www.google.com/url?sa=i&source=images&cd=&cad=rja&uact=8&ved=2ahUKEwju-YP5ubngAhUZJ7kGHW3sBh0QjRx6BAgBEAU&url=https%3A%2F%2Fwww.vexels.com%2Fpng-svg%2Fpreview%2F153290%2Fprocessor-colored-stroke-icon&psig=AOvVaw1WUKC5hk0o7m5ZshcC5XiZ&ust=1550172819720274",
    authUrl: "https://api.strategy.quiteja.com.br/oauth/login",
    appsUrl: "https://auth.gorillascode.com",
    tasksUrl: "https://tasks.quiteja.com.br/v1",
    healthCheckUrl: "https://api.healthcheck.quiteja.com.br/v1/",
  },
};
if (host.includes("pr-")) {
  configs[host] = {
    name: "staging",
    sentryDns:
      "https://cba67de0335b4c51b97cbc4719a7f6f9@o92838.ingest.sentry.io/5496390",
    owner: "QuiteJá",
    ownerUrl: "https://quiteja.com.br",
    pageTitle: "strategy - STAGING",
    cookiesDomain: '.strategy.quiteja.staging.gorillascode.com',
    apiUrl: "https://api.strategy.quiteja.staging.gorillascode.com/v1",
    logo: "https://www.google.com/url?sa=i&source=images&cd=&cad=rja&uact=8&ved=2ahUKEwju-YP5ubngAhUZJ7kGHW3sBh0QjRx6BAgBEAU&url=https%3A%2F%2Fwww.vexels.com%2Fpng-svg%2Fpreview%2F153290%2Fprocessor-colored-stroke-icon&psig=AOvVaw1WUKC5hk0o7m5ZshcC5XiZ&ust=1550172819720274",
    authUrl:
      "https://api.strategy.quiteja.staging.gorillascode.com/oauth/login",
    appsUrl: "https://auth.staging.gorillascode.com",
    tasksUrl: "https://tasks.quiteja.staging.gorillascode.com/v1",
    healthCheckUrl: "https://api.healthcheck.gorillascode.com/v1",
  }
}

export default {
  name: configs[host].name,
  owner: configs[host].owner,
  ownerUrl: configs[host].ownerUrl,
  pageTitle: configs[host].pageTitle,
  apiUrl: configs[host].apiUrl,
  logo: configs[host].logo,
  authUrl: configs[host].authUrl,
  cookiesDomain: configs[host].cookiesDomain,
  renderUrl: configs[host].renderUrl,
  externalRefUrl: configs[host].externalRefUrl,
  appsUrl: configs[host].appsUrl,
  tasksUrl: configs[host].tasksUrl,
  healthCheckUrl: configs[host].healthCheckUrl,
  sentryDns: configs[host].sentryDns,
};
